"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestFullQAAction = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const request_full_qa_action_styles_1 = require("./request-full-qa-action.styles");
const use_request_full_qa_hook_1 = require("../../hooks/use-request-full-qa.hook");
const hooks_1 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
const RequestFullQAAction = ({ nodeTitle, attributeName, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addSuccess } = (0, hooks_1.useNotification)();
    const { isEscalated, toggleRequestFullQA, isLoading, isRequestFullQaAllowed, } = (0, use_request_full_qa_hook_1.useRequestFullQA)({ nodeTitle, attributeName });
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [escalationReasonDraft, setEscalationReasonDraft] = (0, react_1.useState)('');
    const onClosePopper = (0, react_1.useCallback)(() => {
        setAnchorEl(null);
        setEscalationReasonDraft('');
    }, []);
    const submitRequestFullQA = (0, react_1.useCallback)((isEscalated) => __awaiter(void 0, void 0, void 0, function* () {
        const isSuccess = yield toggleRequestFullQA(isEscalated, escalationReasonDraft);
        if (isSuccess) {
            onClosePopper();
            addSuccess(t({ key: 'HLQA_REQUEST_FULL_QA_SUCCESS_MESSAGE' }));
        }
    }), [addSuccess, escalationReasonDraft, onClosePopper, t, toggleRequestFullQA]);
    const onEscalationReasonDraftChange = (0, react_1.useCallback)((event) => {
        setEscalationReasonDraft(event.target.value);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ui_components_1.ButtonV2, { color: "primary", variant: !isEscalated ? 'contained' : 'outlined', title: t({ key: isEscalated ? 'HLQA_CANCEL_FULL_QA' : 'HLQA_REQUEST_FULL_QA' }), onClick: (event) => {
            if (isEscalated) {
                void submitRequestFullQA(false);
                return;
            }
            setAnchorEl(event.currentTarget);
        }, disabled: !isRequestFullQaAllowed }), react_1.default.createElement(request_full_qa_action_styles_1.StyledRequestFullQAPopper, { open: !isEscalated && !!anchorEl, anchorEl: anchorEl, transition: true, placement: "bottom-end" }, ({ TransitionProps }) => (react_1.default.createElement(material_1.Fade, Object.assign(Object.assign({}, TransitionProps), { timeout: 150 }), react_1.default.createElement("div", null, react_1.default.createElement(request_full_qa_action_styles_1.StyledRequestFullQAPaper, null, react_1.default.createElement(ui_components_1.TextField, { multiline: true, fullWidth: true, variant: "outlined", value: escalationReasonDraft, onChange: onEscalationReasonDraftChange, placeholder: t({ key: 'HLQA_REQUEST_FULL_QA_REASON_PLACEHOLDER' }), maxRows: 4, minRows: 2 }), react_1.default.createElement(request_full_qa_action_styles_1.StyledRequestFullQAActions, null, react_1.default.createElement(ui_components_1.ButtonV2, { variant: "text", title: t({ key: 'CANCEL' }), onClick: onClosePopper }), react_1.default.createElement(ui_components_1.ButtonV2, { disabled: isLoading, loading: isLoading, variant: "contained", title: t({ key: 'SAVE' }), onClick: () => submitRequestFullQA(true) })))))))));
};
exports.RequestFullQAAction = RequestFullQAAction;
